"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quote = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importDefault(require("styled-components"));
var useTheme_1 = require("../../hooks/useTheme");
var StyledBlockquote = styled_components_1.default.blockquote(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* .lagom-quote */\n  margin-bottom: 2rem;\n  padding-left: 1rem;\n  border-left: 4px solid var(--lagom-semantic-color-border-default);\n  display: inline-block;\n  font-family: var(--lagom-core-font-families-serif);\n  font-style: italic;\n  font-size: var(--lagom-core-font-sizes-xl);\n  color: var(--lagom-semantic-color-fg-muted);\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: var(--lagom-core-font-families-serif);\n  }\n\n  ", " {\n    border-left: 2px solid var(--lagom-semantic-color-border-default);\n    font-size: var(--lagom-core-font-sizes-body);\n  }\n\n  ", " {\n    width: 130%;\n    margin: 0 -15% 2rem -15%;\n    padding-left: 2rem;\n  }\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  /* .lagom-quote */\n  margin-bottom: 2rem;\n  padding-left: 1rem;\n  border-left: 4px solid var(--lagom-semantic-color-border-default);\n  display: inline-block;\n  font-family: var(--lagom-core-font-families-serif);\n  font-style: italic;\n  font-size: var(--lagom-core-font-sizes-xl);\n  color: var(--lagom-semantic-color-fg-muted);\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: var(--lagom-core-font-families-serif);\n  }\n\n  ", " {\n    border-left: 2px solid var(--lagom-semantic-color-border-default);\n    font-size: var(--lagom-core-font-sizes-body);\n  }\n\n  ", " {\n    width: 130%;\n    margin: 0 -15% 2rem -15%;\n    padding-left: 2rem;\n  }\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.large;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.emphasized;
});
var Quote = function (_a) {
    var children = _a.children, className = _a.className, restProps = __rest(_a, ["children", "className"]);
    var mergedTheme = (0, useTheme_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(StyledBlockquote, __assign({ theme: mergedTheme, className: (0, clsx_1.default)("lagom-quote", className) }, restProps, { children: children })));
};
exports.Quote = Quote;
var templateObject_1;
//# sourceMappingURL=Quote.js.map